<template>
	<div class="">
    <div class="label-standard">
      <RequiredAsterisk v-if="required"></RequiredAsterisk>
      {{ label }}
    </div>

	  <div class="form-line">
			<select 
				:value="value == null ? -1 : value"
				v-on:change="updateValue({
          objectType: objectType,
          index     : index,
          key       : propertyKey, 
          value     : $event.target.value,
        })"
				class="select-standard">
				<option value="-1" disabled>Select an option</option>
        <option value="0">Mr</option>
				<option value="1">Mrs</option>
				<option value="2">Ms</option>
				<option value="3">Miss</option>
				<option value="4">Dr</option>
				<option value="5">Prof</option>
				<option value="6">Rev</option>
			</select>
		</div>
	</div>
</template>

<script>
  
  import RequiredAsterisk from '@/shared/components/form/RequiredAsterisk'

  export default {

    components : {
      RequiredAsterisk
    },

    props : {
      label : {
        type    : String,
        required: false,
        default : 'Title'
      },

    	objectType : {
				type    : String,
				required: false
    	},

      propertyKey : {
        type    : String,
        required: false
      },

      updateValue : {
        type : Function,
        required : false
      },

      value : {
        // type    : String,
        required: false
      },

      index : {
        type    : Number,
        required: false
      },

      required : {
        type    : Boolean,
        required: false,
        default : false
      }
    },
  }
</script>